const selectPredefinedEvents = state => state.data.predefinedEvents

const PredefinedEventDataStoreSelectors = {
  predefinedEvents: selectPredefinedEvents
}

export default PredefinedEventDataStoreSelectors
